/* eslint-disable import/prefer-default-export */
import React from 'react';
import { Box, Typography } from '@mui/material';
import DEFAULT_PRODUCT from 'Images/default_product.png';

const TitleStyle = {
  color: 'rgba(112, 112, 112, 0.88)',
  fontSize: '12px',
  fontWeight: 500,
  background: 'rgba(56, 72, 92, 0.11)',
  borderBottom: 'none',
  textTransform: 'uppercase',
};

const rowStyle = { background: '#FFF' /* boxShadow: '0px 12px 26px #0000000D', border: 'none' */ };

export const columns = [
  {
    id: 'reference', // genericArticles , articleText, images
    label: 'Reference',
    style: TitleStyle,
    parentRowStyle: { ...rowStyle, borderRadius: '0 12px' },
    render: ({ row }) => (
      <Box sx={{ display: 'flex', borderLeft: !row.isTecdoc && '3px solid #3A87CE', pl: 0.5 }}>
        <img
            // eslint-disable-next-line no-return-assign
          onError={(e) => {
            e.target.onerror = null;
            e.target.src = DEFAULT_PRODUCT;
          }}
          style={{ width: 50, maxHeight: 50 }}
          src={row.isTecdoc ? (row.img || DEFAULT_PRODUCT) : `https://media.copima.ma/products/${row?.img}`}
          alt={row?.fId}
        />
        <Box sx={{ ml: 0.5 }}>
          <Typography sx={{ color: '#3A87CE', fontSize: '16px', fontWeight: 500 }}>{row.reference}</Typography>
          <Typography sx={{ color: '#333D66', fontSize: '16px', fontWeight: 500 }}>{row.des}</Typography>
        </Box>
      </Box>
    ),
  },
  {
    id: 'fId',
    label: 'Famille',
    style: TitleStyle,
    parentRowStyle: rowStyle,
    render: ({ value }) => (
      <Typography sx={{ color: '#333D66', fontSize: '16px', fontWeight: 500 }}>{value || '-'}</Typography>
    ),
  },
  {
    id: 'bId',
    label: 'Marque',
    style: TitleStyle,
    parentRowStyle: rowStyle,
    render: ({ value }) => (
      <Typography sx={{ color: '#333D66', fontSize: '16px', fontWeight: 500 }}>{value || '-'}</Typography>
    ),
  },
  {
    id: 'p',
    label: 'Prix Net',
    style: TitleStyle,
    parentRowStyle: rowStyle,
    render: ({ row }) => (
      <Typography sx={{ color: '#333D66', fontSize: '16px', fontWeight: 500 }}>
        {row?.isTecdoc ? '-' : ((row?.p * (100.0 - (row?.r || 0))) / 100.0)?.toFixed(2)}
      </Typography>
    ),
  },
  {
    id: 'sB',
    label: 'Stock Réel',
    style: TitleStyle,
    parentRowStyle: { ...rowStyle, borderRadius: '12px 0' },
    render: ({ row }) => (
      <>
        <Typography sx={{ color: '#333D66', fontSize: '16px', fontWeight: 500 }}>
          {row.isTecdoc ? '-' : `BO: ${row?.sB}`}
        </Typography>
        <Typography sx={{ color: '#333D66', fontSize: '16px', fontWeight: 500 }}>
          {row.isTecdoc ? '-' : `DO: ${row.sD}`}
        </Typography>
      </>
    ),
  },
];
